import axios from "axios";
import { baseURL } from "../globals/constants";
import { AddCategoryValues } from "../utils/forms";
import { Dispatch } from "redux";
import { setCategoriesData } from "../redux/slices/CategorySlice";
import { showErrorToast } from "../utils/Toast";
import { NavigateFunction } from "react-router-dom";
import i18next from "i18next";

export const getAllCategories = async (
  dispatch: Dispatch,
  isMobile: boolean,
  navigate: NavigateFunction,
  pageLimit?: number,
  pageNo?: number
) => {
  const token = localStorage.getItem("access_token");
  try {
    const response = await axios.get(`${baseURL}/v1/categories`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch(setCategoriesData(response.data));
    return response.data.results;
  } catch (error: any) {
    console.log("error ", error);
    if (error.response.status == 401) {
      showErrorToast(i18next.t("messages.sessionExpired"), isMobile);
      localStorage.removeItem("access_token");
      navigate("/");
    }
  }
};

export const addNewCategory = async (
  values: AddCategoryValues,
  isMobile: boolean,
  navigate: NavigateFunction
) => {
  const token = localStorage.getItem("access_token");
  try {
    const response = await axios.post(`${baseURL}/v1/categories`, values, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error: any) {
    if (error.response.status == 401) {
      showErrorToast(i18next.t("messages.sessionExpired"), isMobile);
      localStorage.removeItem("access_token");
      navigate("/");
    } else {
      const message =
        error?.response?.data?.message || "An error occurred while adding new category";
      showErrorToast(message, isMobile);
    }
  }
};

export const deleteCategory = async (id: string, isMobile: boolean, navigate: NavigateFunction) => {
  const token = localStorage.getItem("access_token");
  try {
    const response: any = await axios.delete(`${baseURL}/v1/categories/${id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error: any) {
    if (error.response.status == 401) {
      showErrorToast(i18next.t("messages.sessionExpired"), isMobile);
      localStorage.removeItem("access_token");
      navigate("/");
    }
    console.log("error ", error);
  }
};

export const getCategoriesById = async (
  categoryId: string,
  isMobile: boolean,
  navigate: NavigateFunction
) => {
  const token = localStorage.getItem("access_token");
  try {
    const response = await axios.get(`${baseURL}/v1/categories/${categoryId}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    if (error.response.status == 401) {
      showErrorToast(i18next.t("messages.sessionExpired"), isMobile);
      localStorage.removeItem("access_token");
      navigate("/");
    }
    console.log("error ", error);
  }
};

export const updateCategory = async (
  values: AddCategoryValues,
  categoryId: string,
  isMobile: boolean,
  navigate: NavigateFunction
) => {
  const token = localStorage.getItem("access_token");
  try {
    const response = await axios.put(`${baseURL}/v1/categories/${categoryId}`, values, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    if (error.response.status == 401) {
      showErrorToast(i18next.t("messages.sessionExpired"), isMobile);
      localStorage.removeItem("access_token");
      navigate("/");
    } else {
      const message = error?.response?.data?.message || "An error occurred while updating category";
      showErrorToast(message, isMobile);
    }
  }
};
